export class DumbMemberDiscount {
    discountId: number;
    value: string;
    logoUrl: string;
    wasClaimed: boolean;
    validThroughString: string;
    validFromString: string;
    companyName: string;
    limit: number;
    limitString: string;
    validFrom: Date;
    validThrough: Date;
}
